export default "__VITE_ASSET__BFUhsZmK__"